import React from 'react';
import './BookingList.css';

const BookingList = ({ children, visible = true }) => {
  if (!visible) {
    return null;
  }

  return <div className="booking-list-shell">{children}</div>;
};

export default BookingList;
